import { createFileRoute } from "@tanstack/react-router";
import { queryOptions } from "@tanstack/react-query";
import Blog from "@/pages/site/Blog";
import { listWpBlogPosts } from "@/lib/wpBlog.functions";

export const wpPostsQueryOptions = queryOptions({
  queryKey: ["wp-blog-posts"],
  queryFn: () => listWpBlogPosts(),
  staleTime: 5 * 60 * 1000,
});

export const Route = createFileRoute("/blog/")({
  loader: ({ context }) => context.queryClient.ensureQueryData(wpPostsQueryOptions),
  component: () => <Blog />,
});
